import { Container } from "@mui/material"
import Flexbox from "../components/Flexbox"

const Users = ({ title }) => {
    document.querySelector('title').innerHTML = title

    return (
        <Container>
            <Flexbox justifyContent="center" alignItems="center" style={{ height: '70vh' }}>
                <div style={{ textAlign: 'center' }}>
                    <p style={{ fontWeight: 700, fontSize: '18px', margin: 0 }}>Users</p>
                    <small style={{ opacity: .5 }}>In development</small>
                </div>
            </Flexbox>
        </Container>
    )
}

export default Users
